import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useTierUsageSubscription } from 'hooks/useTierUsageSubscription'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useRootStore } from 'stores/RootStore'

export const TieredUsageListener = observer(() => {
  const workspaceId = useCurrentWorkspaceId()
  const tierUsageStore = useRootStore().tierUsageStore

  useEffect(() => {
    tierUsageStore.refetch(workspaceId)
  }, [tierUsageStore, workspaceId])

  useTierUsageSubscription({
    workspaceId,
    onUpdate: tierUsageStore.setTierInfo,
    onPlanUpdate: () => tierUsageStore.refetch(workspaceId),
  })

  return null // This component doesn't render anything
})
